(function () {
  'use strict';

  function parseQS(qs) {
    const out = new URLSearchParams(qs || '');

    function alias(fromArr, to) {
      fromArr.forEach((k) => {
        if (out.has(k) && !out.has(to)) out.set(to, out.get(k));
      });
    }

    alias(['firstname', 'first', 'first_name'], 'first_name');
    alias(['lastname', 'last', 'last_name'], 'last_name');
    alias(['mail', 'email_address'], 'email');
    alias(['zip', 'postcode', 'postal_code'], 'zip');

    return out;
  }

  function hasEmailInQS(qs) {
    const src = parseQS(qs);
    const email = src.get('email');
    return !!(email && String(email).trim().length);
  }

  function buildCheckoutQS(originalQS) {
    const src = parseQS(originalQS);
    const dst = new URLSearchParams();

    src.forEach((v, k) => { dst.set(k, v); });

    if (src.get('email')) dst.set('checkout[email]', src.get('email'));
    if (src.get('first_name')) dst.set('checkout[shipping_address][first_name]', src.get('first_name'));
    if (src.get('last_name')) dst.set('checkout[shipping_address][last_name]', src.get('last_name'));
    if (src.get('phone')) dst.set('checkout[shipping_address][phone]', src.get('phone'));
    if (src.get('address1')) dst.set('checkout[shipping_address][address1]', src.get('address1'));
    if (src.get('address2')) dst.set('checkout[shipping_address][address2]', src.get('address2'));
    if (src.get('city')) dst.set('checkout[shipping_address][city]', src.get('city'));
    if (src.get('zip')) dst.set('checkout[shipping_address][zip]', src.get('zip'));
    if (src.get('country')) dst.set('checkout[shipping_address][country]', src.get('country'));
    if (src.get('province')) dst.set('checkout[shipping_address][province]', src.get('province'));

    return dst.toString();
  }

  function cartPermalinkCheckout(variantId, qty, qs) {
    const checkoutQS = buildCheckoutQS(qs || '');
    const base = `/cart/${encodeURIComponent(String(variantId))}:${encodeURIComponent(String(qty || 1))}`;
    const step = 'step=contact_information';
    if (!checkoutQS) return `${base}?${step}`;
    return `${base}?${checkoutQS}&${step}`;
  }

  function clearCart() {
    return fetch('/cart/clear', { method: 'POST', credentials: 'same-origin' });
  }

  function initSection(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    try {
      localStorage.removeItem('oneid:lastResult');
    } catch (_) {}

    const currentQS = window.location.search || '';
    if (!hasEmailInQS(currentQS) && window.location.pathname.indexOf('/pages/assessment') !== 0) {
      window.location.replace('/pages/assessment');
      return;
    }

    root.querySelectorAll('[data-med-choice-back]').forEach((link) => {
      if (link.getAttribute('href') === '#') {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          try { history.back(); } catch (_) {}
        });
      }
    });

    root.querySelectorAll('[data-med-choice-card]').forEach((card) => {
      const btn = card.querySelector('[data-med-choice-checkout]');
      if (!btn) return;

      const variantId = btn.dataset.variantId;
      const redirectUrl = btn.dataset.redirectUrl;

      if (variantId) {
        btn.disabled = false;
      } else if (!redirectUrl) {
        btn.disabled = true;
      }

      btn.addEventListener('click', () => {
        if (!hasEmailInQS(window.location.search || '')) {
          window.location.assign('/pages/assessment');
          return;
        }

        const oldText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Redirecting...';

        if (redirectUrl) {
          const qs = window.location.search || '';
          const separator = redirectUrl.indexOf('?') >= 0 ? '&' : '?';
          window.location.assign(redirectUrl + (qs ? separator + qs.slice(1) : ''));
          return;
        }

        if (!variantId) {
          btn.disabled = false;
          btn.textContent = oldText;
          return;
        }

        const checkoutUrl = cartPermalinkCheckout(variantId, 1, window.location.search || '');

        clearCart()
          .then(() => {
            window.location.assign(checkoutUrl);
          })
          .catch(() => {
            btn.disabled = false;
            btn.textContent = oldText;
            window.location.assign('/checkout');
          });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-select-product]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-select-product]');
    if (root) initSection(root);
  });
})();
